module.exports = __webpack_public_path__ + "img/home.44c5addc.png";